module.exports = __webpack_public_path__ + "static/media/car.db3b400a.svg";